import store from "@/store";

const hasParam = (to, name) => !!to.params[name];

const isAuthenticated = () => {
  const user = store.getters["user/user"];
  const roles = store.getters["role/roles"];
  const features = store.getters["feature/features"];
  const organizations = store.getters["organization/organizations"];
  return user && organizations && features && roles;
};

const hasOrganizationFeature = feature => {
  const result = store.getters["feature/hasOrganizationFeature"](feature);
  return result;
};

const hasOrganizationRole = (to, role) => {
  // params
  if (!hasParam(to, "organizationId")) return false;

  // check
  const roles = store.getters["role/roles"];
  const organizationRoles = roles[to.params.organizationId] || [];
  return organizationRoles.some(r => r === role);
};

const isVerensics = () => {
  const organization = store.getters["organization/organization"];
  if (!organization) return false;
  const roles = store.getters["role/roles"];
  const organizationRoles = roles[organization.id] || [];
  return organizationRoles.some(r => r == "verensics-administrator");
};

const isUser = to => {
  // params
  if (!hasParam(to, "organizationId")) return false;
  if (!hasParam(to, "userId")) return false;

  // org admin
  if (hasOrganizationRole(to, "organization-administrator")) return true;

  // check
  const user = store.getters["user/user"];
  return to.params.userId === user.id;
};

const policyMap = {
  authenticated: isAuthenticated,
  user: isUser,
  "verensics-administrator": isVerensics,
};

export default {
  run: (to, from, next) => {
    // has meta
    var hasRoles = to.meta && to.meta.authorization && to.meta.authorization.roles && to.meta.authorization.roles.length;
    var hasFeatures = to.meta && to.meta.authorization && to.meta.authorization.features && to.meta.authorization.features.length;
    var hasPolicies = to.meta && to.meta.authorization && to.meta.authorization.policies && to.meta.authorization.policies.length;
    if (!hasRoles && !hasFeatures && !hasPolicies) {
      next();
      return;
    }

    // is authenticated
    if (!isAuthenticated(to)) {
      store.dispatch("signin/setRedirect", to.path);
      next("/signin");
      return;
    }

    // verensics
    if (isVerensics(to)) {
      next();
      return;
    }

    // roles
    const passRoles = !hasRoles || to.meta.authorization.roles.some(code => hasOrganizationRole(to, code));

    // features
    const passFeatures = !hasFeatures || to.meta.authorization.features.some(code => hasOrganizationFeature(code));

    // policies
    const passPolicies =
      !hasPolicies ||
      to.meta.authorization.policies.some(p => {
        const policy = policyMap[p];
        return policy && policy(to);
      });

    if (passFeatures && passRoles && passPolicies) {
      next();
      return;
    }

    next("/404");
  },
};
